import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateCompanyTaxParameterRequestSchema,
  TUpdateCompanyTaxParameterResponseSchema,
} from "./updateCompanyTaxParameter.schema";

export const updateCompanyTaxParameter = (axios: IAxiosInstance) => {
  return async (body: TUpdateCompanyTaxParameterRequestSchema) => {
    try {
      const response = await axios.noRetry.patch<
        IApiResponse<TUpdateCompanyTaxParameterResponseSchema>
      >(`/api/internal/employees/company-tax-parameter`, body);

      const { data } = response.data;

      return data;
    } catch (error: any) {
      throw new Error(
        (error?.response.data.errors &&
          error.response.data.errors[0].message) ||
          "Error updating company tax parameter. Please contact support."
      );
    }
  };
};
